class CollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    if (this.tabs.length === 0) return;

    // Create tablist wrapper and move tab buttons into it
    const tablist = document.createElement('div');
    tablist.className = 'collection-tabs__tablist';
    tablist.setAttribute('role', 'tablist');

    this.tabs.forEach((tab) => {
      tablist.appendChild(tab);
    });

    this.prepend(tablist);

    // Set first tab as active
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', i === 0);
      tab.setAttribute('tabindex', i === 0 ? '0' : '-1');
    });

    this.panels.forEach((panel, i) => {
      if (i === 0) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });

    this.tablist = this.querySelector('[role="tablist"]');
    this.initDragScroll();
  }

  initDragScroll() {
    const el = this.tablist;
    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    el.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      el.style.cursor = 'grabbing';
    });

    el.addEventListener('mouseleave', () => {
      isDown = false;
      el.style.cursor = '';
    });

    el.addEventListener('mouseup', () => {
      isDown = false;
      el.style.cursor = '';
    });

    el.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > 5) isDragging = true;
      el.scrollLeft = scrollLeft - walk;
    });

    // Prevent tab click when dragging
    el.addEventListener('click', (e) => {
      if (isDragging) {
        e.stopPropagation();
        e.preventDefault();
        isDragging = false;
      }
    }, true);
  }

  switchTab(index) {
    this.tabs.forEach((tab, i) => {
      const isSelected = i === index;
      tab.setAttribute('aria-selected', isSelected);
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.panels.forEach((panel, i) => {
      if (i === index) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    // Force slideshow components in the newly visible panel to recalculate
    // Use requestAnimationFrame to wait for browser reflow after removing hidden
    const activePanel = this.panels[index];
    if (activePanel) {
      requestAnimationFrame(() => {
        activePanel.querySelectorAll('slideshow-component').forEach((slideshow) => {
          if (slideshow.select && slideshow.current !== undefined) {
            slideshow.select(slideshow.current, undefined, { animate: false });
          }
        });
      });
    }

    this.tabs[index].focus();
    this.tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  handleKeydown(event, currentIndex) {
    let newIndex;

    switch (event.key) {
      case 'ArrowRight':
        newIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.switchTab(newIndex);
  }
}

customElements.define('collection-tabs', CollectionTabs);
